import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";

const testimonial = {
  quote:
    "The Purple Space Children's Library has made a wonderful difference in the lives of my 10- and 13-year-old children. Their screen time has been replaced by reading books. The stories they read have helped them develop their vocabulary, creativity, and imagination — and to understand feelings and learn good values. The library is truly helping them discover the joy of reading.",
  author: "A Purple Space parent",
  detail: "Reading with us since preschool",
};

export const Testimonial = () => (
  <section
    data-testid="testimonial-section"
    className="border-y border-ink/10 bg-plum py-28 text-cream md:py-36"
  >
    <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
      <Reveal>
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-terracotta text-cream">
          <Quote size={22} />
        </span>
        <blockquote
          data-testid="testimonial-quote"
          className="mt-10 font-serif text-2xl italic leading-snug tracking-tight sm:text-3xl md:text-4xl"
        >
          "{testimonial.quote}"
        </blockquote>
        <div className="mt-10">
          <p data-testid="testimonial-author" className="text-sm font-semibold uppercase tracking-[0.25em] text-terracotta">
            {testimonial.author}
          </p>
          <p className="mt-2 text-sm text-cream/70">{testimonial.detail}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
